// Контейнер для монтирования на странице
// Для отображения уведомлений в правом нижнем углу экрана
// <Alerts alId='container'/>
// Сообщения описаны в MessageContext.jsx
// Используется Toastify -библиотека для создания уведомлений в React-приложениях
// import Toastify from 'toastify-js';
// const { setMess } = useContext(MessageContext);

import React from 'react'

const Alerts = () => {
    return (
        <div role="region" tabIndex="-1">
            <ol id="alerts" tabIndex="-1" className="fixed z-[100] flex max-h-screen w-full px-2 bottom-10 right-0 top-auto flex-col sm:max-w-[420px] gap-2  transition-all duration-500">
            </ol>
        </div>
    );
}

export default Alerts